export const SUCCESS_STORIES_BLOG_CATEGORY_SLUG = 'casos-de-exito';
export const SUCCESS_STORIES_BLOG_CATEGORY_ID = '324';

export const FEATURED_POST_SLUG = 'succes-case-contratar-head-of-engineering';
export const FEATURED_POST_ID = '14742';
